import { AxiosError } from 'axios';

export class ApiError extends Error {
  status?: number;
  code?: string;
  details?: unknown;
  requestId?: string;
  isNetworkError: boolean;

  constructor(message: string, options?: {
    status?: number;
    code?: string;
    details?: unknown;
    requestId?: string;
    isNetworkError?: boolean;
  }) {
    super(message);
    this.name = 'ApiError';
    this.status = options?.status;
    this.code = options?.code;
    this.details = options?.details;
    this.requestId = options?.requestId;
    this.isNetworkError = Boolean(options?.isNetworkError);
  }
}

const normalizeMessage = (message: unknown, fallback: string) => {
  if (Array.isArray(message)) {
    return message.filter(Boolean).join('；') || fallback;
  }

  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  return fallback;
};

export const normalizeApiError = (error: unknown): ApiError => {
  if (error instanceof ApiError) {
    return error;
  }

  const axiosError = error as AxiosError<{ message?: string; code?: string }>;
  const status = axiosError.response?.status;
  const data = axiosError.response?.data;
  const message = normalizeMessage(data?.message, axiosError.message || '请求失败');
  const requestIdHeader = axiosError.response?.headers?.['x-request-id'];

  return new ApiError(message, {
    status,
    code: data?.code,
    details: data,
    requestId: Array.isArray(requestIdHeader) ? requestIdHeader[0] : requestIdHeader,
    isNetworkError: Boolean(axiosError.request && !axiosError.response),
  });
};

export const getErrorMessage = (error: unknown, fallback: string) => {
  return normalizeMessage(normalizeApiError(error).message, fallback);
};
